import { Button, ButtonGroup, Modal } from "@veneer/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { updateAuthentication } from "../../features/auth/authenticationSlice";
import { useDispatch } from "react-redux";

const InactivityMessage = () => {
  const [t] = useTranslation("global");
  const [open, setOpen] = useState(false);
  const [inactivityTime, setInactivityTime] = useState(0);
  const dispatch = useDispatch();

  const INACTIVITY_LIMIT =
    Number(process.env.REACT_APP_INACTIVITY_TIME) * 60 * 1000;

  const resetTimeout = () => {
    setInactivityTime(0);
  };

  const closeSession = () => {
    dispatch(updateAuthentication(false));
  };

  useEffect(() => {
    // Monitorea la actividad global del usuario
    const handleUserActivity = (event: Event) => {
      const target = event.target;

      // Validar que sea un elemento HTML antes de usar closest()
      if (target instanceof HTMLElement) {
        if (target.closest(".modal") || target.closest("body")) {
          resetTimeout();
        }
      } else {
        // Si no es HTMLElement igualmente reseteamos
        resetTimeout();
      }
    };

    document.addEventListener("mousemove", handleUserActivity);
    document.addEventListener("keydown", handleUserActivity);
    document.addEventListener("click", handleUserActivity);
    document.addEventListener("scroll", handleUserActivity);
    window.addEventListener("focus", resetTimeout);

    const intervalId = setInterval(() => {
      setInactivityTime((prevTime) => {
        if (prevTime >= INACTIVITY_LIMIT) {
          setOpen(true);
        }
        return prevTime + 1000;
      });
    }, 1000);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener("mousemove", handleUserActivity);
      document.removeEventListener("keydown", handleUserActivity);
      document.removeEventListener("click", handleUserActivity);
      document.removeEventListener("scroll", handleUserActivity);
      window.removeEventListener("focus", resetTimeout);
    };
  }, []);

  return (
    <div>
      <Modal
        align="start"
        id="modal-id"
        show={open}
        footer={
          <ButtonGroup>
            <Button onClick={closeSession}>{t("header.confirm")}</Button>
          </ButtonGroup>
        }
        title={t("header.information")}
      >
        <p>
          {t("header.inactivityMessage")}{" "}
          {Number(process.env.REACT_APP_INACTIVITY_TIME)} {t("header.minutes")}{" "}
          {t("header.loginAgain")}
        </p>
      </Modal>
    </div>
  );
};

export default InactivityMessage;
